import React, { useState, useMemo } from 'react';
import { FiUpload, FiInfo, FiEdit2, FiGrid, FiMessageSquare } from 'react-icons/fi';
import './UserConfig.scss';

const UserConfig = () => {
  const [activeTab, setActiveTab] = useState('account');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    position: 'Ejecutivo de atención al cliente',
    personType: 'Interno',
    locations: []
  });

  const [modules, setModules] = useState({
    dashboard: {
      resumen: true,
      automatizacion: false,
      speechAnalytics: false,
      encuestas: false
    },
    fineTunning: {
      informacionNegocio: true,
      respuestasFrecuentes: true,
      productos: true,
      tiendas: true,
      medios: false
    },
    bots: true,
    asistenteIA: {
      automatizacion: true,
      campanias: true,
      gestorCitas: false,
      mensajeRecuperacion: false,
      baseDatos: true,
      bandejaMensajes: false,
      calendario: false,
      usuarios: false
    }
  });

  const [notifications, setNotifications] = useState({
    resultados: false,
    reclamos: false,
    asistencia: false,
    citas: false
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLocationChange = (locations) => {
    setFormData(prev => ({
      ...prev,
      locations
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form data:', formData);
  };

  const isAccountComplete = useMemo(() => {
    return (
      formData.name.trim() !== '' &&
      formData.phone.trim() !== '' &&
      formData.email.trim() !== '' &&
      formData.password.trim() !== '' &&
      formData.locations.length > 0
    );
  }, [formData]);

  const isAccessComplete = useMemo(() => {
    // Verificar si al menos un módulo está seleccionado en cada sección
    const hasSelectedDashboard = Object.values(modules.dashboard).some(value => value);
    const hasSelectedFineTunning = Object.values(modules.fineTunning).some(value => value);
    const hasSelectedAssistant = Object.values(modules.asistenteIA).some(value => value);
    
    // Verificar si al menos una notificación está activada
    const hasSelectedNotifications = Object.values(notifications).some(value => value);

    return (
      (hasSelectedDashboard || hasSelectedFineTunning || modules.bots || hasSelectedAssistant) &&
      hasSelectedNotifications
    );
  }, [modules, notifications]);

  const isFormComplete = useMemo(() => {
    return isAccountComplete && isAccessComplete;
  }, [isAccountComplete, isAccessComplete]);
//CREAR USUARIO EN EL BACKEND
  const handleCreateUser = async () => {
    if (!isFormComplete) return;

    const endpoint = 'http://localhost:3004/users';

    const payload = {
      ...formData,
      modules,
      notifications,
    };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Si usas autenticación, agrega aquí el token
          // 'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Error al crear usuario');
      }

      const data = await response.json();
      console.log('Usuario creado exitosamente:', data);
    } catch (error) {
      console.error('Error al crear usuario:', error);
      throw new Error('Error al crear usuario');
    }
  };

  const handleSaveAccess = async () => {
    const endpoint = `http://localhost:3004/users/${userId}`;

    const payload = {
      modules,
      notifications,
    };

    try {
      const response = await fetch(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Error al guardar accesos');
      }

      // const data = await response.json();
      // ... lógica de éxito ...
    } catch (error) {
      // ... lógica de error ...
    }
  };

  const renderAccountTab = () => (
    <form onSubmit={handleSubmit} className="user-config-form">
      <div className="user-config-form__section">
        <h3 className="user-config-form__subtitle">
          Información personal
          <span className="info-icon">
            <FiInfo />
          </span>
        </h3>

        <div className="profile-photo">
          <div className="profile-photo__placeholder">
            {/* Aquí iría la imagen de perfil */}
          </div>
          <button type="button" className="uc-btn uc-btn--outline">
            <FiUpload />
            Subir imagen
          </button>
        </div>

        <div className="form-group">
          <label htmlFor="name">Nombre</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Escribe el nombre completo"
            value={formData.name}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Número de contacto</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Escribe el número de contacto"
            value={formData.phone}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Correo electrónico</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Escribe el correo electrónico"
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Contraseña</label>
          <div className="password-input">
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Escribe la contraseña inicial"
              value={formData.password}
              onChange={handleInputChange}
            />
            <button type="button" className="password-edit">
              <FiEdit2 />
            </button>
          </div>
        </div>
      </div>

      <div className="user-config-form__section">
        <h3 className="user-config-form__subtitle">Empresa</h3>
        
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="position">Puesto</label>
            <select
              id="position"
              name="position"
              value={formData.position}
              onChange={handleInputChange}
            >
              <option value="Ejecutivo de atención al cliente">Ejecutivo de atención al cliente</option>
              {/* Agregar más opciones según necesidad */}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="personType">Tipo de personal</label>
            <select
              id="personType"
              name="personType"
              value={formData.personType}
              onChange={handleInputChange}
            >
              <option value="Interno">Interno</option>
              <option value="Externo">Externo</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="locations">Ubicación tiendas</label>
          <div className="locations-select">
            <div className="locations-tags">
              {formData.locations.map((location, index) => (
                <span key={index} className="location-tag">
                  {location}
                  <button
                    type="button"
                    onClick={() => {
                      const newLocations = formData.locations.filter((_, i) => i !== index);
                      handleLocationChange(newLocations);
                    }}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
            <select
              id="locations"
              onChange={(e) => {
                if (e.target.value && !formData.locations.includes(e.target.value)) {
                  handleLocationChange([...formData.locations, e.target.value]);
                }
              }}
              value=""
            >
              <option value="">Seleccionar ubicación</option>
              <option value="Oficina Miraflores">Oficina Miraflores</option>
              <option value="Oficina B">Oficina B</option>
              {/* Agregar más opciones según necesidad */}
            </select>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <button type="submit" className="uc-btn uc-btn--success">
          Cambios guardados
        </button>
      </div>
    </form>
  );

  const renderModules = () => (
    <div className="modules-grid">
      <div className="modules-grid__section">
        <div className="module-item">
          <div className="modules-grid__header">
            <FiGrid />
            Dashboard
          </div>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.dashboard.resumen ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 dashboard: { ...prev.dashboard, resumen: !prev.dashboard.resumen }
               }))} />
          <span className="module-item__label">Resumen</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.dashboard.automatizacion ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 dashboard: { ...prev.dashboard, automatizacion: !prev.dashboard.automatizacion }
               }))} />
          <span className="module-item__label">Automatización</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.dashboard.speechAnalytics ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 dashboard: { ...prev.dashboard, speechAnalytics: !prev.dashboard.speechAnalytics }
               }))} />
          <span className="module-item__label">Speech analytics</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.dashboard.encuestas ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 dashboard: { ...prev.dashboard, encuestas: !prev.dashboard.encuestas }
               }))} />
          <span className="module-item__label">Encuestas</span>
        </div>

        <div className="module-item mt-4">
          <div className="modules-grid__header">
            <FiGrid />
            Fine - Tunning
          </div>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.fineTunning.informacionNegocio ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 fineTunning: { ...prev.fineTunning, informacionNegocio: !prev.fineTunning.informacionNegocio }
               }))} />
          <span className="module-item__label">Información del negocio</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.fineTunning.respuestasFrecuentes ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 fineTunning: { ...prev.fineTunning, respuestasFrecuentes: !prev.fineTunning.respuestasFrecuentes }
               }))} />
          <span className="module-item__label">Respuestas frecuentes</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.fineTunning.productos ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 fineTunning: { ...prev.fineTunning, productos: !prev.fineTunning.productos }
               }))} />
          <span className="module-item__label">Productos</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.fineTunning.tiendas ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 fineTunning: { ...prev.fineTunning, tiendas: !prev.fineTunning.tiendas }
               }))} />
          <span className="module-item__label">Tiendas</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.fineTunning.medios ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 fineTunning: { ...prev.fineTunning, medios: !prev.fineTunning.medios }
               }))} />
          <span className="module-item__label">Medios</span>
        </div>

        <div className="module-item mt-4">
          <div className={`module-item__checkbox ${modules.bots ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 bots: !prev.bots
               }))} />
          <span className="module-item__label">Bots</span>
        </div>
      </div>

      <div className="modules-grid__section">
        <div className="module-item">
          <div className="modules-grid__header">
            <FiMessageSquare />
            Asistente IA
          </div>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.automatizacion ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, automatizacion: !prev.asistenteIA.automatizacion }
               }))} />
          <span className="module-item__label">Automatización</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.campanias ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, campanias: !prev.asistenteIA.campanias }
               }))} />
          <span className="module-item__label">Campañas</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.gestorCitas ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, gestorCitas: !prev.asistenteIA.gestorCitas }
               }))} />
          <span className="module-item__label">Gestor de citas</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.mensajeRecuperacion ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, mensajeRecuperacion: !prev.asistenteIA.mensajeRecuperacion }
               }))} />
          <span className="module-item__label">Mensaje de recuperación</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.baseDatos ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, baseDatos: !prev.asistenteIA.baseDatos }
               }))} />
          <span className="module-item__label">Base de datos</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.bandejaMensajes ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, bandejaMensajes: !prev.asistenteIA.bandejaMensajes }
               }))} />
          <span className="module-item__label">Bandeja de mensajes</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.calendario ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, calendario: !prev.asistenteIA.calendario }
               }))} />
          <span className="module-item__label">Calendario</span>
        </div>
        <div className="module-item">
          <div className={`module-item__checkbox ${modules.asistenteIA.usuarios ? 'module-item__checkbox--checked' : ''}`}
               onClick={() => setModules(prev => ({
                 ...prev,
                 asistenteIA: { ...prev.asistenteIA, usuarios: !prev.asistenteIA.usuarios }
               }))} />
          <span className="module-item__label">Usuarios</span>
        </div>
      </div>
    </div>
  );

  const renderAccessTab = () => (
    <div>
      <section className="modules-section">
        <h3 className="modules-section__title">Visualización de módulos</h3>
        <p className="modules-section__description">
          Selecciona los módulos a los que tendrá acceso cada usuario.
        </p>
        {renderModules()}
      </section>

      <section className="notifications-section">
        <h3 className="notifications-section__title">Notificaciones</h3>
        <div className="notifications-section__card">
          <div className="notification-item">
            <div className="notification-item__content">
              <h4>Resultados y encuestas</h4>
              <p>Recibe notificaciones de los resultados y encuestas.</p>
            </div>
            <div className={`notification-item__toggle ${notifications.resultados ? 'notification-item__toggle--active' : ''}`}
                 onClick={() => setNotifications(prev => ({
                   ...prev,
                   resultados: !prev.resultados
                 }))} />
          </div>
          
          <div className="notification-item">
            <div className="notification-item__content">
              <h4>Reclamos y quejas</h4>
              <p>Recibe notificaciones en tiempo real sobre los reclamos y quejas de los clientes para asegurar una respuesta rápida y efectiva.</p>
            </div>
            <div className={`notification-item__toggle ${notifications.reclamos ? 'notification-item__toggle--active' : ''}`}
                 onClick={() => setNotifications(prev => ({
                   ...prev,
                   reclamos: !prev.reclamos
                 }))} />
          </div>

          <div className="notification-item">
            <div className="notification-item__content">
              <h4>Asistencia humana</h4>
              <p>Recibe notificaciones para derivar el caso a la persona adecuada y ofrecer una atención especializada.</p>
            </div>
            <div className={`notification-item__toggle ${notifications.asistencia ? 'notification-item__toggle--active' : ''}`}
                 onClick={() => setNotifications(prev => ({
                   ...prev,
                   asistencia: !prev.asistencia
                 }))} />
          </div>

          <div className="notification-item">
            <div className="notification-item__content">
              <h4>Citas agendadas</h4>
              <p>Recibe notificaciones de las citas agendadas con el cliente.</p>
            </div>
            <div className={`notification-item__toggle ${notifications.citas ? 'notification-item__toggle--active' : ''}`}
                 onClick={() => setNotifications(prev => ({
                   ...prev,
                   citas: !prev.citas
                 }))} />
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="uc-btn uc-btn--success"
              onClick={handleSaveAccess}
            >
              Guardar cambios
            </button>
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <div className="user-config-view">
      <h1 className="user-config-view__title">Usuarios</h1>

      <div className="user-config-card">
        <div className="user-config-card__header">
          <div>
            <h2 className="user-config-card__title">Configuración de usuario</h2>
            <p className="user-config-card__description">
              En esta sección podrás personalizar tus datos de usuario.
            </p>
          </div>
          <button 
            className={`uc-btn uc-btn--secondary ${isFormComplete ? 'active' : ''}`}
            onClick={handleCreateUser}
          >
            Crear usuario
          </button>
        </div>

        <div className="user-config-card__tabs">
          <button 
            className={`tab-btn ${activeTab === 'account' ? 'tab-btn--active' : ''}`}
            onClick={() => setActiveTab('account')}
          >
            Mi cuenta
          </button>
          <button 
            className={`tab-btn ${activeTab === 'access' ? 'tab-btn--active' : ''}`}
            onClick={() => setActiveTab('access')}
          >
            Accesos y notificaciones
          </button>
        </div>

        {activeTab === 'account' ? renderAccountTab() : renderAccessTab()}
      </div>
    </div>
  );
};

export default UserConfig; 
